import { Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { NumericFormat } from 'react-number-format';


function CaseUsageExploration({ caseItemLogs, cardItems, recommendations, setSelectedItem, selectedCategories = [], topCategories = [] }) {
    // apply category filter (supports 'Other' which represents categories not in topCategories)
    const filtered = (caseItemLogs || []).filter(log => {
        if (!selectedCategories || selectedCategories.length === 0) return true;
        const orig = log.item.category || 'Uncategorized';
        const mapped = topCategories && topCategories.includes(orig) ? orig : 'Other';
        return selectedCategories.includes(mapped);
    });

    const logsSortedByCategory = filtered.sort((a, b) => {
        const aCat = topCategories && topCategories.includes(a.item.category || 'Uncategorized') ? (a.item.category || 'Uncategorized') : 'Other';
        const bCat = topCategories && topCategories.includes(b.item.category || 'Uncategorized') ? (b.item.category || 'Uncategorized') : 'Other';
        if (aCat < bCat) return -1;
        if (aCat > bCat) return 1;
        return 0;
    });

    function isItemOnCard(log) {
        return cardItems[log.item.category] && cardItems[log.item.category].some(item => item.id === log.item.id);
    }

    function hasCurrentRecommendation(log) {
        return recommendations.some(rec => rec.item.id === log.item.id);
    }

    return (
        <Stack spacing={2}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Case Date</TableCell>
                        <TableCell>Item Name</TableCell>
                        <TableCell>Item Category</TableCell>
                        <TableCell>Is on Card?</TableCell>
                        <TableCell>Has Current Rec?</TableCell>
                        <TableCell>Open Quantity</TableCell>
                        <TableCell>Hold Quantity</TableCell>
                        <TableCell>Used Quantity</TableCell>
                        <TableCell>Used Cost</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {logsSortedByCategory.map((log) => (
                        <TableRow 
                            key={log.id} 
                            hover
                            sx={{ cursor: 'pointer' }}
                            onClick={() => setSelectedItem(log.item)}
                        >
                            <TableCell>{new Date(log.date_of_service).toLocaleDateString()}</TableCell>
                            <TableCell>{log.item.name}</TableCell>
                            <TableCell>{log.item.category}</TableCell>
                            <TableCell>{isItemOnCard(log) ? 'Yes' : 'No'}</TableCell>
                            <TableCell>{hasCurrentRecommendation(log) ? 'Yes' : 'No'}</TableCell>
                            <TableCell>{log.open_quantity}</TableCell>
                            <TableCell>{log.hold_quantity}</TableCell>
                            <TableCell>{log.used_quantity}</TableCell>
                            <TableCell>
                                <NumericFormat
                                    value={(log.used_quantity * log.item.cost) / 100}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Stack>
    );
}

export default CaseUsageExploration;
